import React from 'react';
import { newToastMessage } from '@Containers/ToastMessages/ToastMessagesActions';
import { InfoToastMessageTitle, InfoToastMessageContent } from '@Containers/ToastMessages/InfoToastMessage/InfoToastMessage';

// eslint-disable-next-line import/prefer-default-export
export const showInfoToastMessage = ({ title, content }) =>
  newToastMessage({
    iconId: '#icon-information',
    ...(title && { title: <InfoToastMessageTitle title={title} /> }),
    ...(content && { content: <InfoToastMessageContent content={content} /> }),
    className: 'info-toast-message',
    color: 'secondary',
  });
